export const QA_NAME_VISIBILITY_VISIBLE = 'visible'

export const QA_NAME_VISIBILITY_INVISIBLE = 'invisible'

export const QA_NAME_VISIBILITY_CONTEXT = 'visibility'
